// extracted by mini-css-extract-plugin
export default {"creator-block":"styles_creator-block__jq0t7","creator-block__info":"styles_creator-block__info__0W8al"};